// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
// import {Settings_context} from '../../settings_ctx';
import zescape from '/util/escape.js';
import {is_state_with_banner, login_process} from './utils';
import {t_states} from './types';
import {img_url} from '../img_url';
import {Check_email, State_reset_password} from './state_reset_password';
import {State_signup_check_email} from './state_signup_check_email';
import {use_qs} from '../../lib/use_qs';
import {State_with_banner} from './state_with_banner';
// @ts-ignore
import {App_context} from '../../context.js';
import {useLocation} from 'react-router-dom';
import {Settings_context} from '../../settings_ctx';
import {www_hola} from 'hola_opt';

interface i_form_props {
    Banner?: JSX.Element;
    no_banner?: boolean;
    blocks?: {
        social?: {[propname: string]: boolean},
    };
    default_state?: t_states;
    enc_url?: string;
    signup_bonus?: boolean;
    next?: string;
    qr_code?: string;
    can_signup: boolean;
    need_plus?: boolean;
    full_page?: boolean;
    small_height?: boolean;
    global_back?: boolean;
    img_set?: 'hola'|'toolip';
    support_email?: string;
    help_email?: string;
}

export const Default_banner = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.default_banner}>
      <img src={img_url('hola2023/surf.svg')} alt="surf"
        className={cn(styles.surf, 'lazyload')}/>
      <div className={styles.banner_text}>
        <h5>Access worldwide content</h5>
        <p className={theme.u5}>Your gateway to your favorite movies,
          TV shows, games and more, no matter where you live!</p>
      </div>
    </div>;
};

export const Toolip_banner = ()=>{
    return <div className={styles.toolip_banner}>
      <img src={img_url('pro/toolip.png')} alt="toolip"
        className={cn(styles.toolip, 'lazyload')}/>
    </div>;
};

export const Form = (p:i_form_props)=>{
    const {theme} = useContext(Settings_context);
    const [states, set_states] = useState<t_states[]>(['empty',
        p.default_state || 'login_buttons', 'empty_end']);
    const [signup_subscription, set_signup_subscription] = useState(true);
    // @ts-ignore
    const {has_svc, svc_info} = useContext(App_context);
    const {pathname} = useLocation();
    useEffect(()=>{
        if (www_hola.send_ga_events && states[1]=='login_buttons')
        {
            try {
                (window as any).dataLayer.push({event:
                    'gtag.login_form_view'});
            } catch(e){}
        }
        if (www_hola.send_ga_events && states[1]=='signup_buttons')
        {
            try {
                (window as any).dataLayer.push({event:
                    'gtag.signup_form_view'});
            } catch(e){}
        }
    }, [states[1]]);
    let pro_signup = pathname=='/pro' || pathname=='/pro/checkout'
        || pathname=='/pro/products';
    const get_enc_url = ()=>{
        let {enc_url, signup_bonus, next, qr_code} = p;
        let generic = '?'+zescape.qs({
            next: next || location.href,
            signup_bonus: signup_bonus ? 1 : undefined,
            qr_code,
            uuid: has_svc ? svc_info.uuid : undefined,
            pro_signup: pro_signup ? true : undefined,
        });
        return enc_url ? enc_url + '&' + zescape.qs({
            uuid: has_svc ? svc_info.uuid : undefined,
            pro_signup: pro_signup ? true : undefined,
        }) : generic;
    };
    const go_to = (state:t_states, direction?: number)=>{
        try {
            // @ts-ignore
            window.mtcaptcha.remove();
        } catch(e){}
        if (direction==-1)
        {
            set_states(current_state=>[state, current_state[1],
                current_state[2]]);
            setTimeout(()=>{
                set_states(current_state=>['empty', state, current_state[1]]);
                setTimeout(()=>{
                    set_states(['empty', state, 'empty_end']);
                }, 300);
            }, 0);
            return;
        }
        set_states(current_state=>[current_state[0], current_state[1], state]);
        setTimeout(()=>{
            set_states(current_state=>[current_state[1], state, 'empty_end']);
            setTimeout(()=>{
                set_states(['empty', state, 'empty_end']);
            }, 300);
        }, 0);
    };
    useEffect(()=>{
        const state_changed = login_process.on('state_changed', ()=>{
            if (login_process.state=='waiting_for_two_step')
                go_to('two_factor');
        });
        return state_changed;
    }, []);
    const {debug_no_fixed_h} = use_qs();
    const states_wrap = states.map(s=>is_state_with_banner(s) ? 'with_banner' :
      s);
    if (states_wrap[0]=='with_banner' && states_wrap[1]=='with_banner')
        states_wrap[0] = 'empty';
    if (states_wrap[2]=='with_banner' && states_wrap[1]=='with_banner')
        states_wrap[2] = 'empty_end';
    return <div className={cn(styles.root, theme.root,
      debug_no_fixed_h ? styles.min_h : styles.fixed_h,
      p.full_page ? styles.full_page : styles.max_height,
      p.img_set == 'toolip' ? styles.toolip_height : '',
      p.small_height && styles.small_height)}
      style={{
        '--root_form_width': p.img_set == 'toolip' ? '768px' : '736px',
        '--foot_width': p.img_set == 'toolip' ? '352px' : '280px',
      } as any}>
      <div className={cn(styles.form)} key={'form_with_slide'}>
        {states_wrap.map((state, i)=>{
          return <div className={cn(styles.slide,
            i==0 && styles.prev,
            i==2 && styles.next)} key={state}>
            {state=='reset_password' && <State_reset_password go_to={go_to}
              img_set={p.img_set}/>}
            {state=='reset_password_done' && <Check_email go_to={go_to}
              img_set={p.img_set}/>}
            {(state=='signup_check_email' ||
            state=='resend_premium_verification') &&
              <State_signup_check_email go_to={go_to} img_set={p.img_set}
                support_email={p.support_email}
                get_enc_url={get_enc_url} email={login_process.last_email}/>}
            {state=='with_banner' && <State_with_banner {...p} go_to={go_to}
              get_enc_url={get_enc_url}
              pro_signup={pro_signup}
              support_email={p.support_email}
              img_set={p.img_set}
              set_signup_subscription={set_signup_subscription}
              signup_subscription={signup_subscription} states={states}
              global_back={p.global_back}/>}
          </div>;
        })}
      </div>
    </div>;
};
